import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const checkMediCalBenefitRestrict = (cptCode: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.CHECK_MEDI_CAL_BENEFIT_RESTRICT_REQUEST });

  return api.authorization.mediCal.checkRestrict(cptCode)
    .then((res: any) => {

      dispatch({
        type: types.CHECK_MEDI_CAL_BENEFIT_RESTRICT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CHECK_MEDI_CAL_BENEFIT_RESTRICT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const checkMediCalCode = (hpCode: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.CHECK_MEDI_CAL_CODE_REQUEST });

  return api.authorization.mediCal.checkCode(hpCode)
    .then((res: any) => {

      dispatch({
        type: types.CHECK_MEDI_CAL_CODE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CHECK_MEDI_CAL_CODE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  